<doc>
    @desc:   布局 - 人机认证组件
    @author:  
  </doc>
<template>
    <div class="g-recaptcha" id="grecaptcha" ref="grecaptcha"></div>
</template>
<script>
export default {
  data() {
    return {
      sitekey: "6LeLHlwpAAAAAHEhlCQxOoPCL-Lq61Q5KvMzQvzk"
    };
  },

  methods: {
    loaded() {
        if(typeof(window) != 'undefined'){
            setTimeout(() => {
              grecaptcha.enterprise.render(this.$refs.grecaptcha, {
                    sitekey: this.sitekey,
                    /**
                    * res返回的是goole的验证情况，
                    * 成功返回字符串
                    * 失败不返回字符串
                    * 所以根据字符串判断验证情况
                    */
                    callback: res => {
                        res.length > 0 ? 
                        // true  - 验证成功
                        // false - 验证失败
                        this.$emit("getValidateCode", res) : 
                        this.$emit("getValidateCode", false)
                    }
                });
            }, 1000);
        }
    }
  },
  mounted() {
    if(typeof(window) != 'undefined'){
        var script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/enterprise.js?render=explicit";
        document.head.appendChild(script);
        this.loaded();
    }
  }
};
</script>
<style>
.g-recaptcha{
  
}
.g-recaptcha iframe{
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// ./src/components/reCaptcha.vue